import {showErrorMessage} from '@/helper';

export default {
    getAll(clientId) {
        return new Promise((resolve, reject) => {
            http.get(`api/clients/${clientId}/meeting-records/`).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    fetchRecords(clientId, body) {
        return new Promise((resolve, reject) => {
            http.post(`api/clients/${clientId}/meeting-records/list`, {
                page: body.page,
                search: body.search,
                length: body.pageLength,
                order: [{'column': body.orderColumn, 'dir': body.orderAsc ? 'asc' : 'desc'}],
                filter: body.filter
            }).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    saveMeetingRecord(clientId, data) {
        return new Promise((resolve, reject) => {
            http.post('api/clients/' + clientId + '/meeting-records' + (data.id ? '/' + data.id : ''), data).then(response => {
                resolve(response.data);
            }).catch(error => {
                if (error.response?.data?.message) {
                    showErrorMessage(error.response.data.message);
                }
                reject([]);
            });
        });
    },

    deleteRecord(clientId, recordId) {
        return new Promise((resolve, reject) => {
            http.delete('api/clients/' + clientId + '/meeting-records/' + recordId).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    }
}
